import React, { useEffect, useState } from "react";
import "./css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const countriesInfo = [
  {
    countryVideo: require("../../assets/countryVideos/germany.mp4"),
    countryName: "GERMANY",
    countryShort: "Germany",
  },
  {
    countryVideo: require("../../assets/countryVideos/usa.mp4"),
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
  },
  {
    countryVideo: require("../../assets/countryVideos/uk.mp4"),
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
  },
  {
    countryVideo: require("../../assets/countryVideos/canada.mp4"),
    countryName: "CANADA",
    countryShort: "Canada",
  },
  {
    countryVideo: require("../../assets/countryVideos/dubai.mp4"),
    countryName: "U.A.E",
    countryShort: "U.A.E",
  },
  {
    countryVideo: require("../../assets/countryVideos/australia.mp4"),
    countryName: "AUSTRALIA",
    countryShort: "Australia",
  },
];

export default function LifeStyle(props) {
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryImg: require("./images/country-1.png"),
    countryName: "GERMANY",
    countryShort: "Germany",
  });

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = countriesInfo.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(countriesInfo[countryInfo]);
    }
  }, [props.selectedTab]);

  return (
    <div className="life-style-wrapper">
      <div className="title text-center wow bounceIn" data-wow-duration="2s">
        <span>EXPLORE {selectedCountryInfo.countryShort}</span>
      </div>
      <div className="youtube-video">
        <iframe
          src={selectedCountryInfo.countryVideo}
          title={selectedCountryInfo.countryName}
          height="400"
          playsInline
          preload="auto"
          frameBorder="0"
          allowFullScreen="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </div>
  );
}
